import React, {PropTypes, Component} from 'react'

class ContactName extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    attendeeInfo: PropTypes.object.isRequired
  }


  render(){
    const {attendeeInfo} = this.props
    const {attendee_name} = attendeeInfo

    let full_name = attendee_name.split(' ')
    let initial = full_name[0][0] + full_name[1][0]

    return(
      <div className='class-status'>
        <div className='initial'>{initial}</div>
        <span>{attendee_name}</span>
      </div>
    )
  }
}


export default (ContactName)



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/RegistrationTable/ContactName.js